import { ANIMATION_DELTA_THRESHOLD } from './ANIMATION_DELTA_THRESHOLD'

export const ANIMATION_PROPERTY_DELTA_PAIRS: [string, number][] = [
  ['x', ANIMATION_DELTA_THRESHOLD],
  ['y', ANIMATION_DELTA_THRESHOLD],
  ['width', ANIMATION_DELTA_THRESHOLD],
  ['height', ANIMATION_DELTA_THRESHOLD],
  ['sx', ANIMATION_DELTA_THRESHOLD / 100],
  ['sy', ANIMATION_DELTA_THRESHOLD / 100],
  ['opacity', ANIMATION_DELTA_THRESHOLD / 100],
  ['fontSize', ANIMATION_DELTA_THRESHOLD / 10],
]
